import axios from "axios";

import { getToken, removeToken, decodeToken } from "./tokenUtils";
import { history } from "./navigateUtils";
import { apiUrl } from "config/envConfig";
const axiosInstance = axios.create({
  baseURL: apiUrl,
});

const userTimeZone = new Date().getTimezoneOffset() / -60;

// Add Authorization header to all requests if a token exists and the en nor arabic to everthing was used using the http
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    const userLanguage = localStorage.getItem("language") || "en";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["Accept-Language"] = userLanguage;
    config.headers["usertimezone"] = userTimeZone;

    // If token contains a UserId claim, include it in headers for endpoints
    // that expect the acting user's id in `UserId` header (e.g. approve uploads).
    try {
      if (token) {
        const decoded = decodeToken(token);
        const uid = decoded?.UserId ?? decoded?.userId ?? decoded?.sub ?? decoded?.Id ?? null;
        if (uid) config.headers["UserId"] = String(uid);
      }
    } catch (e) {
      // decoding failure should not block requests
      // eslint-disable-next-line no-console
      console.debug('Failed to decode token for UserId header', e);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      removeToken();
      history.push("/sign-in");
    }
    return Promise.reject(error);
  }
);

const http = {
  get: axiosInstance.get,
  post: axiosInstance.post,
  put: axiosInstance.put,
  delete: axiosInstance.delete,
  patch: axiosInstance.patch,
};

export default http;
